export const PENDING_SHARE_KEY = 'pendingShareImport';
export const PENDING_SHARE_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function readPendingShareToken() {
    try {
        const params = new URLSearchParams(window.location.search);
        const queryToken = params.get('share');
        if (queryToken) return queryToken;

        const raw = sessionStorage.getItem(PENDING_SHARE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.token) return null;
        const age = Date.now() - (parsed.savedAt || 0);
        if (age > PENDING_SHARE_MAX_AGE_MS) {
            sessionStorage.removeItem(PENDING_SHARE_KEY);
            return null;
        }
        return parsed.token;
    } catch (_) {
        return null;
    }
}

export function clearPendingShare() {
    try {
        sessionStorage.removeItem(PENDING_SHARE_KEY);
    } catch (_) {
        // sessionStorage may be unavailable; ignore.
    }
}

export function writePendingShare(token) {
    try {
        const stored = sessionStorage.getItem(PENDING_SHARE_KEY);
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                const age = Date.now() - (parsed.savedAt || 0);
                if (parsed.token === token && age < PENDING_SHARE_MAX_AGE_MS) {
                    return;
                }
            } catch (_) {
                // fallthrough to overwrite
            }
        }
        sessionStorage.setItem(
            PENDING_SHARE_KEY,
            JSON.stringify({ token, savedAt: Date.now() })
        );
    } catch (_) {
        // sessionStorage may be unavailable; ignore.
    }
}
